export enum NewsletterFormsWhatsAppEnabledPreconditionState {
  Met = "met",
  NotMet = "not_met"
}

export type GetNewsletterFormsWhatsAppEnabledResponse = {
  enabled: boolean;
  canEnable: boolean;
  preconditions: {
    whatsappIntegration: NewsletterFormsWhatsAppEnabledPreconditionState;
    legalText: NewsletterFormsWhatsAppEnabledPreconditionState;
    designSettings: NewsletterFormsWhatsAppEnabledPreconditionState;
  };
};
